import React, { useEffect, useState } from 'react';
import leaveAPI from '../api/leaveAPI';
import UserDashboard from './UserDashboard';

const LeaveReportmyo = () => {
  const [leaves, setLeaves] = useState([]);

  // Fetch all leave applications
  const fetchLeaves = async () => {
    try {
      const res = await leaveAPI.get('/all');
      setLeaves(res.data);
    } catch (err) {
      console.error('Error fetching leave data:', err);
    }
  };

  useEffect(() => {
    fetchLeaves();
  }, []);

  // Update leave status (Approve or Reject)
  const updateStatus = async (id, status) => {
    try {
      await leaveAPI.patch(`/${id}/status`, { status });
      fetchLeaves(); // Refresh after update
    } catch (err) {
      console.error('Error updating status:', err);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 to-pink-100 pt-16">
         <UserDashboard />
      <div className="max-w-7xl mx-auto p-8">
        <div className="bg-white p-4 rounded-2xl shadow-xl">
          <h2 className="text-3xl font-mono font-bold text-purple-700 mb-3 text-center">
            Leave Report
          </h2>

          {/* Scrollable area with dynamic height */}
          <div className="overflow-x-auto overflow-y-auto max-h-[calc(100vh-250px)] border rounded-lg">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-purple-100 text-purple-700 text-sm font-semibold uppercase sticky top-0 z-10">
                <tr>
                  <th className="py-3 px-4 text-left">Applied Date</th>
                  <th className="py-3 px-4 text-left">Profile</th>
                  <th className="py-3 px-4 text-left">Name</th>
                  <th className="py-3 px-4 text-left">Role</th>
                  <th className="py-3 px-4 text-left">Work Mode</th>
                  <th className="py-3 px-4 text-left">Leave Type</th>
                  <th className="py-3 px-4 text-left">From</th>
                  <th className="py-3 px-4 text-left">To</th> 
                  <th className="py-3 px-4 text-left">Duration</th>
                  <th className="py-3 px-4 text-left">Reason</th>
                  <th className="py-3 px-4 text-left">Status</th>
                </tr>
              </thead>
              <tbody className="text-gray-800 text-sm">
                {leaves.length > 0 ? (
                  leaves.map((leave, index) => (
                    <tr key={index} className="border-t hover:bg-yellow-50 transition">
                      <td className="py-2 px-4">
                        {new Date(leave.createdAt).toLocaleDateString('en-GB')}
                      </td>

                      <td className="py-2 px-4">
                        <img
                          src={leave.profileImage}
                          alt="profile"
                          className="w-10 h-10 rounded-full border mx-auto"
                        />
                      </td>

                      <td className="py-2 px-4">{leave.workerName}</td>
                      <td className="py-2 px-4">{leave.role}</td>
                      <td className="py-2 px-4">{leave.workMode}</td>
                      <td className="py-2 px-4">{leave.leaveType}</td>

                      {/* Conditional From / To */}
                      {leave.leaveType === "Permission" ? (
                        <>
                          <td className="py-2 px-4">
                            {leave.fromTime || "-"}
                          </td>
                          <td className="py-2 px-4">
                            {leave.toTime || "-"}
                          </td>
                        </>
                      ) : (
                        <>
                          <td className="py-2 px-4">
                            {leave.fromDate
                              ? new Date(leave.fromDate).toLocaleDateString("en-GB")
                              : "-"}
                          </td>
                          <td className="py-2 px-4">
                            {leave.toDate
                              ? new Date(leave.toDate).toLocaleDateString("en-GB")
                              : "-"}
                          </td>
                        </>
                      )}

                      <td className="py-2 px-4 font-semibold text-purple-700">
                        {leave.duration}
                      </td>

                      <td className="py-2 px-4">{leave.reason}</td>

                      {/* <td className="py-2 px-4">
                        <span
                          className={`text-xs font-semibold px-3 py-2 rounded-full ${
                            leave.status === 'Approved'
                              ? 'bg-green-100 text-green-700'
                              : leave.status === 'Rejected'
                              ? 'bg-red-100 text-red-600'
                              : 'bg-yellow-100 text-yellow-700'
                          }`}
                        >
                          {leave.status}
                        </span>
                      </td> */}
                      <td className="py-2 px-4">
                      {leave.status === 'Pending' ? (
                        <div className="flex gap-2">
                          <button
                            onClick={() => updateStatus(leave._id, 'Approved')}
                            className="px-3 py-2 bg-green-500 hover:bg-green-600 text-white text-xs rounded-lg"
                          >
                            Approve
                          </button>
                          <button
                            onClick={() => updateStatus(leave._id, 'Rejected')}
                            className="px-3 py-2 bg-red-500 hover:bg-red-600 text-white text-xs rounded-lg"
                          >
                            Reject
                          </button>
                        </div>
                      ) : (
                        <span
                          className={`text-xs font-semibold px-3 py-2 rounded-full ${
                            leave.status === 'Approved'
                              ? 'bg-green-100 text-green-700'
                              : 'bg-red-100 text-red-600'
                          }`}
                        >
                          {leave.status}
                        </span>
                      )}
                    </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="11" className="text-center py-6 text-gray-500">
                      No leave records found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaveReportmyo;
